// import OutcomeConversionService from '../../services/outcome-conversion-service';
/**
 * Model for Player Odds
 */
export default class PlayerOddsModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Competitor ID
     * @type {Number}
     */
    this.competitorId = data.c;
    /**
     * Team Name
     * @type {String}
     */
    this.teamName = data.t;
    /**
     * Player ID
     * @type {Number}
     */
    this.playerId = data.p;
    /**
     * Player First Name
     * @type {String}
     */
    this.firstName = data.fn;
    /**
     * Player Last Name
     * @type {String}
     */
    this.lastName = data.ln;
    /**
     * First Goal Odd
     * @type {Number}
     */
    // this.firstGoalOdd = OutcomeConversionService.outcomeConverter(data.fg);
    /**
     * Original First Goal Odd
     * @type {Number}
     */
    this.originalFirstGoalOdd = data.fg;
    /**
     * Any Goal Odd
     * @type {Number}
     */
    // this.anyGoalOdd = OutcomeConversionService.outcomeConverter(data.at);
    /**
     * Original Any Goal Odd
     * @type {Number}
     */
    this.originalAnyGoalOdd = data.at;
    /**
     * Last Goal Odd
     * @type {Number}
     */
    // this.lastGoalOdd = OutcomeConversionService.outcomeConverter(data.lg);
    /**
     * Original Last Goal Odd
     * @type {Number}
     */
    this.originalLastGoalOdd = data.lg;
    /**
     * Suspended player
     * @type {boolean}
     */
    this.suspended = data.su;
  }
}
